// extracted by mini-css-extract-plugin
export var divider = "_sy-0";
export var systemMessage = "_sy-1";